'use client';

import { motion } from 'framer-motion';

interface AnimatedNumberProps {
  value: string | number;
  className?: string;
}

export const AnimatedNumber = ({ value, className }: AnimatedNumberProps) => {
  return (
    <motion.span
      key={value}
      initial={{ opacity: 0.7 }}
      animate={{ opacity: 1, scale: 0.985 }}
      transition={{
        duration: 0.4,
        ease: 'easeInOut',
      }}
      className={className}
      style={{ display: 'inline-block' }}
    >
      {value}
    </motion.span>
  );
};
